import Vue from "vue";
// import './plugins/axios';
import store from "./store";
import App from "./App.vue";
import router from "./router";
import Permission from "./directives/permission";
import "./components";
import ViewUI from "view-design";
import Validate from "./utils/validate";
import "./styles/theme.less";
import i18n from "./i18n";
import './plugins/element.js'
Vue.use(ViewUI);
Vue.config.productionTip = false;
Vue.directive("permission", Permission);
Vue.prototype.$setTableH = function(top = 94, bottom = 80) {
    let winH = window.innerHeight;
    console.log(winH, top, bottom)
    return winH - top - bottom;
}

Vue.prototype.Validate = Validate;

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount("#app");
